import { gql } from '@apollo/client';

export const UPSERT_INSIGHT_TAG = gql`
  mutation upsertInsightTag($input: UpsertInsightTagInput) {
    insightTag: upsertInsightTag(input: $input) {
      id
    }
  }
`;
